<template>
  <div id="AppPasswordInitialization">
    <div style="height: 100px;" />
    <div class="modal-card" style="width: 600px;">
      <header class="modal-card-head" style="border: 1px solid #dbdbdb; padding-top: 0px; padding-bottom: 0px;">
        <img src="../assets/logo.png" width="90px;" height="auto;" />
        <p
          class="modal-card-title has-text-centered"
          style="color: whitesmoke"
        >スケジュール管理システム Philips SMS</p>
      </header>
      <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
        <b-field
          label="メールアドレス"
          :type="{'is-danger': errors.has('userId')}"
          :message="errors.first('userId')"
        >
          <b-input
            name="userId"
            data-vv-as="メールアドレス"
            type="text"
            v-model="userId"
            v-validate="'required|email|max:256'"
            placeholder="メールアドレスを入力してください"
          ></b-input>
        </b-field>
        <b-field
          label="ワンタイムパスワード"
          :type="{'is-danger': errors.has('otp')}"
          :message="errors.first('otp')"
        >
          <b-input
            name="otp"
            data-vv-as="ワンタイムパスワード"
            v-model="otp"
            type="text"
            placeholder="ワンタイムパスワードを入力してください"
            minlength="6"
            maxlength="6"
            v-validate="'required|numeric|length:6'"
          ></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot" style="border: 1px solid #dbdbdb;">
        <div>
          <b-button
            class="button is-primary is-inverted has-text-centered"
            icon-left="send"
            v-on:click="sendPasswordMail"
          >パスワード初期化メール送信</b-button>
          <b-button
            class="button is-light is-inverted has-text-centered"
            type="button"
            v-on:click="back"
          >ログインへ戻る</b-button>
        </div>
      </footer>
    </div>
    <div style="height: 100px;" />
  </div>
</template>

<script>
export default {
  name: "AppPasswordInitialization",
  methods: {
    back: function(event) {
      console.log("back called.");
      this.$router.go(-1);
    },
    sendPasswordMail: function(event) {
      console.log("sendPasswordMail called.");
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch("pwdInit", {
              mail: this.userId,
              otptoken: this.otp,
              showDialog: this.showDialog
            })
            .then(() => {
              this.$router.push({ path: "/" });
            });
        }
      });
    },
    showDialog: function(message) {
      this.$dialog.alert({
        title: "　",
        message: message
      });
    }
  },
  data() {
    return {
      userId: "",
      otp: ""
    };
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>



// WEBPACK FOOTER //
// src/components/AppPasswordInitialization.vue